export default {"src":"/_next/static/media/logo_and_tagline.430d9950.svg","height":70,"width":538,"blurWidth":0,"blurHeight":0};